export default function setupTabs() {
	const { findHtmlEl, findHtmlEls, getClosest, listenDocumentEvent } =
		pm.utils.dom;

	function init() {
		const tabMenus = findHtmlEls(".tab-menu");

		// Initial state of the tabs.
		if (tabMenus.length) {
			tabMenus.forEach(function (tabMenu) {
				const tabsWrapper = getClosest(tabMenu, ".tabs", 5);
				if (!tabsWrapper) return;

				const activeTabMenuItem = findHtmlEl(
					tabMenu,
					".tab-menu-item.is-active",
				);
				if (!activeTabMenuItem) return;

				switchTab(tabsWrapper, activeTabMenuItem.dataset.tabKey);
			});
		}

		listenDocumentEvent("click", ".tab-menu-item", function (e) {
			if (!(e.target instanceof HTMLElement)) return;
			const target = e.target;

			const tabMenu = getClosest(target, ".tab-menu", 5);
			if (!tabMenu) return;

			const tabsWrapper = getClosest(tabMenu, ".tabs", 5);
			if (!tabsWrapper) return;

			const tabContent = findHtmlEl(tabsWrapper, ".tab-content");
			if (!tabContent) return;

			switchTab(tabsWrapper, target.dataset.tabKey);
		});
	}

	function switchTab(tabsWrapper: HTMLElement, key?: string) {
		if (!key) return;

		const tabMenu = findHtmlEl(tabsWrapper, ".tab-menu");

		if (tabMenu) {
			const tabMenuItems = findHtmlEls(tabMenu, ".tab-menu-item");

			if (tabMenuItems.length) {
				tabMenuItems.forEach(function (tabMenuItem) {
					if (tabMenuItem.dataset.tabKey === key) {
						tabMenuItem.classList.add("is-active");
					} else {
						tabMenuItem.classList.remove("is-active");
					}
				});
			}
		}

		const tabContent = findHtmlEl(tabsWrapper, ".tab-content");

		if (tabContent) {
			const tabContentItems = findHtmlEls(tabContent, ".tab-content-item");

			if (tabContentItems.length) {
				tabContentItems.forEach(function (tabContentItem) {
					if (tabContentItem.dataset.tabKey === key) {
						tabContentItem.classList.add("is-active");
					} else {
						tabContentItem.classList.remove("is-active");
					}
				});
			}
		}

		const conditionalEls = findHtmlEls(tabsWrapper, "[data-show-if-tab]");

		if (conditionalEls.length) {
			conditionalEls.forEach(function (conditionalEl) {
				if (conditionalEl.dataset.showIfTab === key) {
					conditionalEl.classList.remove("is-hidden");
				} else {
					conditionalEl.classList.add("is-hidden");
				}
			});
		}

		const tabsGroupName = tabsWrapper.dataset.tabsGroup;

		if (tabsGroupName) {
			pm.event.emit("pm_tabs_switch", {
				tabsGroup: tabsGroupName,
				activeTabKey: key,
			});
		}
	}

	init();
}
